import styled from '@emotion/styled';
import { Layout } from 'antd';

export const SContainer = styled.section`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const SLayout = styled(Layout)`
  background: #f2f2f2;
`;

export const SOutlet = styled.div`
  width: 100%;
  overflow-y: scroll;
`;

export const SSideBar = styled(Layout.Sider)`
  &.ant-layout-sider {
    background: #f2f2f2;
  }
`;
